<template>
    <div>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="teal" icon v-bind="attrs" v-on="on">
                    <v-icon color="teal" dark v-bind="attrs" v-on="on">
                        mdi-plus
                    </v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item-group color="primary">
                    <v-list-item v-for="(item, index) in actionTypes" :key="index">
                        <v-list-item-title @click="addAction(item.value)">{{ item.text }}</v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    props: {
        item: Object,
        user: Object,
    },
    data() {
        return {}
    },
    computed: {
        ...mapState('salesLeads', ["actionTypes"])
    },
    methods: {
        ...mapActions('salesLeads', ['addLeadAction']),
        addAction(type) {
            const newAction = {
                type: type,
                userId: Number(this.user.id_user),
                username: this.user.username,
                leadId: this.item.id
            }
            this.addLeadAction(newAction);
        }
    }
}
</script>